'use client'

interface EventCardSkeletonProps {
  count?: number
}

const EventCardSkeleton = ({ count = 4 }: EventCardSkeletonProps) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="bg-surface border border-surface-border rounded-xl overflow-hidden"
          style={{ animationDelay: `${i * 80}ms` }}
        >
          <div className="h-48 skeleton rounded-none" />
          <div className="p-4 space-y-3">
            <div className="h-5 skeleton w-3/4" />
            <div className="h-4 skeleton w-1/2" />
            <div className="space-y-1.5">
              <div className="h-4 skeleton w-2/3" />
              <div className="h-4 skeleton w-1/2" />
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default EventCardSkeleton
